<template>
    <div id="referalInviteDiv">
          <HeaderVue />
        <div class="loading">
            <div class="loading-img">
                <img src="static/images/walk.gif" alt="">
            </div>
        </div>
        <header class="reg-header passon-header">
        </header>
        <div class="wrapper">
            <div class="pass-on">
                <div class="inner-page reg-content">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-7">
                                <h1 class="red-color">It's time to pass on the goodness</h1>
                                <p>Thank you for being our esteemed customer. You know it’s convenient to get a home blood test
                                    done through Labotist. Now your friends and family can benefit too. We have made it easy
                                    for you to refer a friend to avail our home blood test services.</p>
                                <p>
                                    You get a credit of INR.100 in your Labotist account when your friend books a blood test
                                    with us. Of course, we won't leave your friend behind! They get an instant credit of
                                    INR.150 as soon as they register with us!
                                </p>
                                <h3>Steps to refer:</h3>
                                <ul>
                                    <li>
                                        Login using your Labotist login credentials
                                    </li>
                                    <li>
                                        You will see the message with referral link
                                    </li>
                                    <li>
                                        Share the message and link via your preferred mode - facebook, whatsapp, Instagram,
                                        email, etc
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm-5">
                                <div class="row icon-thr">
                                    <div class="col-sm-1">

                                
                                    </div>
                                    <div class="col-sm-3">
                                        <img src="static/images/Vector Smart Object1.png" alt="" width="50px">
                                        <h2>login</h2>
                                    </div>
                                    <div class="col-sm-3">
                                            <img src="static/images/document.png" alt="" width="50px">
                                            <h2>Copy Referral message</h2>
                                    </div>
                                    <div class="col-sm-3">
                                            <img src="static/images/share.png" alt="" width="50px">
                                            <h2>Share with Friends</h2>
                                    </div>
                                    <div class="col-sm-1">

                        
                                    </div>
                                </div>
                                <div class="ref-form align-center">
                                <h1>Refer Now</h1>
                                <div class="form-group">
                                    <input type="text" class="form-control" id="referralCode" name="referralCode" v-model="referralCode" aria-describedby="emailHelp"
                                        placeholder="Referral Code" disabled>
                                </div>
                                <div class="form-group">
                                    <textarea name="" class="form-control" cols="30" rows="10" v-model="description"></textarea>
                                </div>
                                <div class="form-group">
                                    <input type="text" class="form-control" id="referralUrl" name="referralUrl" ref="copyReferralText" v-on:focus="copyReferralCodeUrl()" v-on:click="copyReferralCodeUrl()" v-model="referralUrl" aria-describedby="emailHelp" data-toggle="tooltip" data-placement="top" title="Copied" placeholder="Link">
                                </div>
                                
                                    <!--<a href=""><i class="fa fa-facebook-square"></i></a>
                                    <a href=""><i class="fa fa-whatsapp-square"></i></a>
                                    <a href=""><i class="fa fa-linkedin-square"></i></a>
                                    <a href=""><i class="fa fa-instagram"></i></a>-->
                                    <social-sharing v-bind:url="referralUrl"
                                                    v-bind:title="description"
                                                    v-bind:description="description"
                                                    v-bind:quote="description"
                                                    v-bind:hashtags="hashtags"
                                                    v-bind:twitter-user="twitterUser"
                                                    inline-template>
                                    <div class="share-btn text-right mt-3">
                                        Share Via :
                                        <!-- <network network="email">
                                            <i class="fa fa-envelope"></i>
                                        </network> -->
                                        <network network="facebook">
                                            <i class="fa fa-facebook-square"></i>
                                        </network>
                                        <network network="twitter">
                                            <i class="fa fa-twitter"></i>
                                        </network>
                                        <!-- <network network="whatsapp">
                                            <i class="fa fa-whatsapp"></i>
                                        </network> -->
                                    </div>
                                    </social-sharing>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="copy-right text-center">
                <p>2017 labotist . All rights received.</p>
            </div> -->
        </div>
        <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'
// import Sidemenu from '@/components/web/Public/Sidemenu'

export default {
  name: 'ReferalLogin',
  components: {
    HeaderVue,
    // Sidemenu,
    FooterVue
  },
  data () {
    return {
      referralCode : '',
      referralUrl : 'https://labotist.com/',
      title : 'Labotist - Referral Program',
      quote : 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.\n ',
      description : 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.\n ',
      hashtags : 'homebloodtest, chennai, bengaluru',
      twitterUser : 'labotist'
    }
  },
  beforeCreate () { },
  created () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') == null) {
      this.$router.push({ path: '/referral/login' })
    }else {
      this.getProfile()
    }
  },
  mounted () {
    this.$hidePageLoading()
    $('input[data-toggle="tooltip"]').tooltip({
        animated: 'fade',
        placement: 'top',
        trigger: 'manual'
    })
  },
  methods : {
    getProfile: function () {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {}
          Promise.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              this.referralCode = res.response.Patient.referralCode;
              this.referralUrl = this.$signupUrl + this.$encryptString(res.response.Patient.referralCode);
            }
            this.$hidePageLoading()
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error('method:getProfile', e)
      }
    },
    copyReferralCodeUrl: function () {
      let referralUrl = document.getElementById('referralUrl')
      setTimeout(function() {
        referralUrl.setSelectionRange(0, referralUrl.value.length);
        document.execCommand("copy");
        $('input[data-toggle="tooltip"]').tooltip("show")
      }, 1);
      setTimeout(function(){
          $('input[data-toggle="tooltip"]').tooltip("hide")
      }, 1000)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/Public/ReferalInvite.vue